import keyBy from 'lodash/keyBy';
import Vue from 'vue';

import { saveWrap } from './helpers';
import constants from '@authoringPlatform/../store/constants';
import * as authorApi from '@authoringPlatform/../api/authors';

const getDefaultState = () => ({
  characters: {},
  themes: constants.THEME_COLORS,
});

export default {
  namespaced: true,

  state: getDefaultState(),

  actions: {
    createAuthor: saveWrap(async ({ commit }, payload) => {
      const newAuthor = await authorApi.createAuthor(payload);
      commit('ADD_AUTHOR', { newAuthor });
      return newAuthor;
    }),

    updateAuthor: saveWrap(async ({ commit }, payload) => {
      await authorApi.updateAuthor({ authorKey: payload.authorKey, payload });
      commit('UPDATE_AUTHOR', { authorKey: payload.authorKey, authorData: payload });
    }),

    deleteAuthor: saveWrap(async ({ commit }, authorKey) => {
      await authorApi.deleteAuthor(authorKey);
      commit('DELETE_AUTHOR', { authorKey });
    }),
  },

  mutations: {
    INITIALIZE_CHARACTERS: (state, { characters }) => {
      const parsedCharacters = characters.map((char) => ({
        ...char,
        questions: new Set(char.questions.map((q) => q.questionKey)),
      }));
      state.characters = keyBy(parsedCharacters, 'authorKey');
    },

    ADD_AUTHOR: (state, { newAuthor }) => {
      Vue.set(state.characters, newAuthor.authorKey, newAuthor);
    },

    UPDATE_AUTHOR: (state, { authorKey, authorData }) => {
      const targetAuthor = state.characters[authorKey];

      Object.entries(authorData).forEach(([authorAttr, val]) => {
        if (authorAttr in targetAuthor) Vue.set(targetAuthor, authorAttr, val);
      });
    },

    DELETE_AUTHOR: (state, { authorKey }) => {
      Vue.delete(state.characters, authorKey);
    },

    ADD_QUESTION_TO_AUTHOR: (state, { authorKey, questionKey }) => {
      const targetAuthor = state.characters[authorKey];

      const newLinkedQuestions = new Set(targetAuthor.questions);
      newLinkedQuestions.add(questionKey);

      Vue.set(targetAuthor, 'questions', newLinkedQuestions);
    },

    REMOVE_QUESTION_FROM_AUTHOR: (state, { authorKey, questionKey }) => {
      const targetAuthor = state.characters[authorKey];

      const newLinkedQuestions = new Set(targetAuthor.questions);
      newLinkedQuestions.delete(questionKey);

      Vue.set(targetAuthor, 'questions', newLinkedQuestions);
    },
  },
};
